module.exports = __webpack_public_path__ + "static/media/vehicle-type-bicycle-blue.97f37849.svg";